import { initReactI18next } from 'react-i18next';
import { format } from 'date-fns';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import yaml from 'js-yaml';

import { PlatformLocale } from './api/generated';

export const EN_US_LOCALE = PlatformLocale['en-US'];
export const HE_IL_LOCALE = PlatformLocale['he-IL'];
export const ES_MX_LOCALE = PlatformLocale['es-MX'];

export const LOCALES = [EN_US_LOCALE, HE_IL_LOCALE, ES_MX_LOCALE] as const;

const instance = i18n.use(Backend).use(LanguageDetector).use(initReactI18next);

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  const { HMRPlugin: hmrPlugin } = await import('i18next-hmr/plugin');
  instance.use(new hmrPlugin({ vite: { client: true } }));
}

instance.init(
  {
    // If a detected or requested language isn't in the list, i18next falls back to fallbackLng.
    supportedLngs: [EN_US_LOCALE, HE_IL_LOCALE, ES_MX_LOCALE],
    fallbackLng: EN_US_LOCALE,
    debug: false,
    detection: {
      // Order of detection methods - localStorage first, this is to override the default: ['querystring', 'hash', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      order: ['localStorage', 'navigator'],
      // Cache user language on localStorage
      caches: ['localStorage']
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.yml',
      parse: yaml.load
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br']
    },
    interpolation: {
      escapeValue: false // React already handles escaping
    }
  } as never,
  () => {
    i18n.services.formatter?.add('datefns', (value, _lang, options: { formatting?: string }) =>
      options.formatting ? format(value, options.formatting) : value
    );
    i18n.services.formatter?.add('percent', (value, _lang, { digits = 0 }: { digits: number }) =>
      new Intl.NumberFormat(_lang, {
        style: 'percent',
        minimumFractionDigits: digits,
        maximumFractionDigits: digits
      }).format(value)
    );
  }
);
